var _line, _line2, _line3, _line4, _line5, _line6, _line7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGridCountPoint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 16.4453,
    x2: 38,
    y2: 16.4453,
    stroke: "#121212"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 22.4457,
    x2: 38,
    y2: 22.4457,
    stroke: "#121212"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 28.4457,
    x2: 38,
    y2: 28.4457,
    stroke: "#121212"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 34.4456,
    x2: 38,
    y2: 34.4456,
    stroke: "#121212"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 15.8701,
    y1: 12,
    x2: 15.8701,
    y2: 39,
    stroke: "#121212"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 24.6133,
    y1: 12,
    x2: 24.6133,
    y2: 39,
    stroke: "#121212"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 33.3538,
    y1: 12,
    x2: 33.3538,
    y2: 39,
    stroke: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGridCountPoint);
export default __webpack_public_path__ + "static/media/icon_grid_count_point.14f8695667497ff49952414748154d6f.svg";
export { ForwardRef as ReactComponent };